
export * from "__barrel_optimize__?names=GoogleIcon&wildcard!=!./capital-gains"
export * from "__barrel_optimize__?names=GoogleIcon&wildcard!=!./capital-gains/schema"